module.exports = __webpack_public_path__ + "img/80008.b2fb432e.png";